<template>
  <div class="chat-panel-wrapper">
    <div class="chat-panel" :class="{
        disabled: !aiExpertEnabled,
        empty: (!chat || !chat.length) && !loading.loadChat }"
    >

      <div v-if="loading.loadChat">
        <v-skeleton-loader class="mx-auto" type="article"></v-skeleton-loader>
      </div>
      <div v-else-if="!chat || !chat.length" class="h-100 d-flex align-center justify-center">
        Начните диалог с AI-экспертом, введя свой запрос или воспользовавшись шаблонами запросов
      </div>
      <div v-else>
        <div v-for="(msg, ind) in chat" :key="ind"
          :class="{'message-text': !msg.filename, 'message-file': msg.filename, 'author-user': msg.author==='user', 'author-ai': msg.author==='ai' }"
          :id="'msg'+ind"
        >
          <img v-if="msg.author==='ai'" src="@/assets/images/ai-expert/avatar-ai.svg" class="avatar-ai">

          <v-progress-circular v-if="msg.author==='user' && msg.loading" size="24" color="primary" indeterminate />

          <img v-else-if="msg.author==='ai' && msg.loading" src="@/assets/images/ai-expert/typing.svg">

          <FileBadge v-else-if="msg.filename" :name="msg.filename" />

          <div v-else v-html="prepareText(msg.text)" />

          <div v-if="msg.error" class="text-right red--text  mt-3 caption">
            {{msg.error}}
          </div>
        </div>
      </div>
    </div>
    <v-tooltip bottom v-if="chat && chat.length">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="grey darken-1" small class="dowload-icon" @click="downloadPdf" icon :loading="loading.pdf" v-bind="attrs" v-on="on">
          <v-icon small>mdi-content-save-outline</v-icon>
        </v-btn>
      </template>
      <span>Сохранить чат в PDF</span>
    </v-tooltip>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import FileBadge from '@/components/ui/FileBadge.vue'
import { downloadFileHelper, escapeHtml } from '@/common/util.js';

export default {
  name: 'ChatPanel',
  components: {
    FileBadge
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      aiExpertEnabled: 'ai/expert/enabled',
      chat: 'ai/expert/chat',
      loading: 'ai/expert/loading',
    }),
  },
  watch: {
    'chat.length'(val) {
      setTimeout(()=>{
        const element = document.getElementById('msg'+(val-1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }
      }, 100)
    }
  },
  methods: {
    ...mapActions({
      chatToPdf: 'ai/expert/chatToPdf',
    }),
    prepareText(text) {
      return text ? escapeHtml(text).replace(new RegExp('\r?\n','g'), '<br />') : ''
    },
    async downloadPdf() {
      const response = await this.chatToPdf()
      try {
        downloadFileHelper(response);
      } catch (err) {
        this.$toast.error(err.message, '', { position: 'topRight' });
      }

    }
  },
  async mounted() {
  },
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
@import "src/assets/styles/variables";

.chat-panel {
  height: calc(100vh - 450px);
  min-height: 400px;
  background-color: #fff;
  overflow-y: scroll;
  position: relative;

  &.disabled {
    background: $color-disabled;
    //padding: 0 20%;
    text-align: center;
  }
  &.empty {
    padding: 0 20%;
    text-align: center;
  }

  .message-text {
    padding: 16px;
    background: #F2FAFF;
    border-radius: 16px;
    margin: 20px 0 20px 0;
    max-width: 70%;
    width: fit-content;
    border: 1px solid #eee;
    position: relative;
    clear: both;
  }

  .author-user {
    margin-left: auto;
    margin-right: 10px;
  }
  .author-ai {
    margin-left: 50px;
    margin-right: auto;
  }
  .avatar-ai {
    position: absolute;
    left: -40px;
    top: 0;
  }

  .message-file {
    max-width: 70%;
    width: fit-content;
    display: inline;
    float: right;
    margin-bottom: 10px;
  }
  
}

.chat-panel-wrapper {
  position: relative;  
  .dowload-icon {
    position: absolute;
    bottom: 4px;
    right: 24px;
    z-index: 110;
    width: 12px;
    height: 12px;    
  }

}
</style>
